import _ from 'underscore';
import { getYahooModel } from '@bingads-webui-react/yahoo-iframe';

export const ManagedByType = Object.freeze({
  Microsoft: 0,
  Yahoo: 1,
  ChinaJV: 2,
});

export const isManagedByYahoo = customer => _.result(customer, 'ManagedBy') === ManagedByType.Yahoo;

export const useYahooModel = (
  defaultmsview,
  permissions,
  currentUser,
  currentCustomer
) => (currentUser && currentCustomer ? getYahooModel({
  isCustomerManagedByYahoo: isManagedByYahoo(currentCustomer),
  defaultMSView: defaultmsview,
  isInternalUser: currentUser.IsInternal,
  permissions: permissions.dynamic,
  allowYahooCustomerAccessMSView: false,
}) : null);
